import { store } from '../state';

const container = document.getElementById('buttons') as HTMLDivElement;

let activeAnimal: string | null = null;

/** Highlight the quick button matching the active search term. */
export function setActiveAnimal(name: string | null): void {
  activeAnimal = name;
  for (const btn of container.querySelectorAll<HTMLElement>('.animal-chip')) {
    btn.classList.toggle('is-active', btn.dataset.name === name);
  }
}

export function renderAnimalButtons(onSelect: (animal: string) => void): void {
  const { animals } = store.get();

  if (animals.length === 0) {
    container.innerHTML = '<p class="muted">No quick buttons yet — add one above.</p>';
    return;
  }

  container.innerHTML = animals
    .map(
      (animal) => `
      <div class="animal-chip ${animal === activeAnimal ? 'is-active' : ''}" data-name="${animal}">
        <button class="chip-label" data-action="select" type="button">${animal}</button>
        <button class="chip-remove" data-action="remove" type="button"
                aria-label="Remove ${animal}" title="Remove">×</button>
      </div>`,
    )
    .join('');

  // Delegated handling (rebind each render is fine for a small list).
  container.onclick = (e) => {
    const el = (e.target as HTMLElement).closest<HTMLElement>('[data-action]');
    if (!el) return;
    const chip = el.closest<HTMLElement>('.animal-chip');
    const name = chip?.dataset.name;
    if (!name) return;
    if (el.dataset.action === 'remove') {
      store.removeAnimal(name);
    } else {
      onSelect(name);
    }
  };
}
